import { Container } from '@bit/ui-common.ui-components/ss-components';
import CandidateRegistrationLayout from '../components/layouts/CandidateRegistrationLayout';
import { ssFormServices, ssFormUtils } from '@bit/ui-common.ui-components/ss-utils';
import { commonData, captcha, help } from '@bit/ui-common.ui-components/ss-common-data';
import * as config from '../components/registration/candidate/formConfig';
import * as candidateRegistrationServices from '../redux/services/candidateRegistrationServices';
import * as updatePasswordServices from 'services/updatePasswordService';
import * as passwordResetServices from '../redux/services/passwordResetServices';
import * as StatusService from 'services/statusService';
import LoginDisabled from './LoginDisabled';
const { generateInitState } = ssFormUtils;

export default Container({
    state: state => ({
        registrationForm: state.registrationForm || null,
        passwordReset: state.passwordReset,
        passwordUpdate: state.passwordUpdate,
        commonData: state.commonData,
        candidate: state.candidate,
        captcha: state.captcha,
        help: state.helpData,
        loginStatus: state.status
    }),
    services: [
        ssFormServices,
        commonData.commonDataServices,
        candidateRegistrationServices,
        help.helpServices,
        captcha.captchaServices,
        updatePasswordServices,
        passwordResetServices,
        StatusService
    ]
}, 
class CandidateRegistration extends React.Component {
    constructor(props) { 
        super(props);
        this.initState();
        const { services } = this.props;
        services.fetchLoginStatus();
    }

    // Initializes all the required form state.
    initState() {
        const { services, registrationForm } = this.props;
        let formConfig = {...config};
        delete formConfig.linkedFormFields;
        for(let f in formConfig) {
            let config = formConfig[f];
            if(!registrationForm[config.key]) 
                services.storeForm(config.key, generateInitState(config));
        }
    }

    render() {
        const {loginStatus} = this.props;
        if (loginStatus.nonPivLogin != 'N') {
            return (<CandidateRegistrationLayout {...this.props} />);
        }else {
            return (
                <LoginDisabled  />
            )
        }
    }
})